import React, { useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { generateFiscalUittrekselPdf } from "services/api";

/**
 * Optional bestemmeling + generate fiscal uittreksel PDF.
 */
export default function UittrekselDialog({ open, onClose, capakey }) {
  const [recipient, setRecipient] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleClose = () => {
    if (loading) return;
    setRecipient("");
    setError(null);
    onClose();
  };

  const handleGenerate = async () => {
    setLoading(true);
    setError(null);
    try {
      const blob = await generateFiscalUittrekselPdf(capakey, recipient.trim() || null);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `uittreksel-${String(capakey).replace(/\//g, "-")}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setRecipient("");
      setError(null);
      onClose();
    } catch (er) {
      setError("Er liep iets fout, probeer het later opnieuw.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Fiscaal uittreksel</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Capakey: {capakey}
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          label="Bestemmeling (optioneel)"
          fullWidth
          value={recipient}
          onChange={(e) => setRecipient(e.target.value)}
          disabled={loading}
        />
        {error && (
          <Typography color="error" variant="body2" sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Annuleren
        </Button>
        <Button color="primary" variant="contained" onClick={handleGenerate} disabled={loading}>
          {loading ? <CircularProgress size={20} color="inherit" /> : "Maak uittreksel"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
